import { productCompareFlyOutStyles as styles } from "@insite/content-library/Components/ProductCompareFlyOut";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import baseTheme from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { buttonIconOnlyCommonStyles, removeButtonCompareButtonStyles } from "@solveindustrial/Utilities/styleguide";

import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.carouselDrawer = {
    ...styles.carouselDrawer,
    cssOverrides: {
        ...styles.carouselDrawer?.cssOverrides,
        scrim: css`
            background-color: ${getColor(colorStrings.commonGlobalGray04)};
            box-shadow: ${getProp("theme.shadows.2")};
            min-height: auto;
            height: auto;

            ${mediaQueriesBP.minMD} {
                min-height: 25vh;
            }
        `,

        drawerContainer: css`
            background-color: ${getColor(colorStrings.commonGlobalGray04)};
            flex-direction: column;
            justify-content: center;
        `,
        drawerBody: css`
            padding: 15px;
            background-color: ${getColor(colorStrings.commonGlobalGray04)};
            box-shadow: none;
            height: auto;
            max-width: ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return `${maxWidths[4]}px`;
            }};
            bottom: 0;

            ${mediaQueriesBP.minMD} {
                padding: 15px;
                position: relative;
                display: flex;
                flex-direction: column;
                gap: 10px;
            }
        `,
        drawerTitle: css`
            background-color: transparent;
        `,
    },
};

styles.headerTitleText = {
    ...styles.headerTitleText,
    variant: "h3",
    css: css`
        margin: 0 0 16px;
    `,
};

styles.carousel = {
    ...styles.carousel,
    prevArrowButton: {
        ...styles.carousel?.prevArrowButton,
        ...buttonIconOnlyCommonStyles,
    },
    nextArrowButton: {
        ...styles.carousel?.nextArrowButton,
        ...buttonIconOnlyCommonStyles,
    },
    nextArrowGridItem: {
        ...styles.carousel?.nextArrowGridItem,
        css: css`
            flex-basis: 3%;
            max-width: 3%;
            padding: 0 5px;

            ${mediaQueriesBP.minMD} {
                flex-basis: 3%;
                max-width: 3%;
            }
        `,
    },
    prevArrowGridItem: {
        ...styles.carousel?.prevArrowGridItem,
        css: css`
            flex-basis: 3%;
            max-width: 3%;
            padding: 0 5px;

            ${mediaQueriesBP.minMD} {
                flex-basis: 3%;
                max-width: 3%;
            }
        `,
    },
    carouselGridItem: {
        ...styles.carousel?.carouselGridItem,
        css: css`
            flex-basis: 94%;
            max-width: 94%;
            padding: 0 10px;
            ${mediaQueriesBP.minMD} {
                flex-basis: 94%;
                max-width: 94%;
            }
        `,
    },
    mainContainer: {
        ...styles.carousel?.mainContainer,
        css: css`
            justify-content: space-between;
        `,
    },
};

styles.removeProductFromCompareButton = {
    ...styles.removeProductFromCompareButton,
    ...removeButtonCompareButtonStyles,
};

styles.carousel = {
    ...styles.carousel,
    carouselSlideInner: {
        ...styles.carousel?.carouselSlideInner,
        css: css`
            padding: 0 10px;
        `,
    },
};
